import React, { useCallback, useEffect, useState } from "react";
import { Box, Container, Stack } from "@mui/material";
import { Header } from "components/Social/Header/Header";
import { EditWindow } from "components/Social/Edit-window/EditWindow";
import { useUserActions, useUserIdSelector } from "store";
import { useActionHook, useNavigate } from "hooks";
import { AsyncContentMui, RoleComponentGuard } from "components";
import { RoleName } from "../../constants";
import { AccessDenied } from "components/Access-denied/AccessDenied";
import { SocialComponent } from "components/Social/Social-component/Social-component";

export const SocialProfile: React.FC = () => {
  const [isEditOpen, setIsEditOpen] = useState(false);
  const userId = useUserIdSelector();
  const navigate = useNavigate();
  const { getProfileData, getProfileMetadata, updateProfileDataAction, updateAvatarAction } = useUserActions();
  const { data, loading, action } = useActionHook(getProfileData);
  const { data: metadata, action: getMetadata } = useActionHook(getProfileMetadata);

  const getProfile = async () => {
    userId && (await action(userId));
  };

  useEffect(() => {
    getProfile();
    getMetadata();
  }, []);

  useEffect(() => {
    if (
      data &&
      !data.asset_allocations.length &&
      !data.industry_expertises.length &&
      !data.hobbies.length &&
      !Object.values(data.asset_classes).length &&
      !data.investments.length &&
      !data.interests.length
    ) {
      setIsEditOpen(true);
    }
  }, []);

  const handleChangeAvatar = useCallback(
    async (avatar: File) => {
      userId && (await updateAvatarAction(userId, avatar));
      getProfile();
    },
    [userId]
  );

  return (
    userId && (
      <RoleComponentGuard
        availableRoles={[RoleName.Admin, RoleName.Analyst, RoleName.TeamViewer]}
        RenderInstead={<AccessDenied redirectClick={() => navigate({ route: "main" })} title="Back home" />}
      >
        <Container
          disableGutters
          maxWidth={false}
          sx={{
            width: "100%",
            height: "100%",
            backgroundColor: "#F6F8FC",
            overflow: "scroll"
            // back
            // backgroundColor: `url(${opportunityBackground})`,
            // backgroundPositionY: "0%",
            // backgroundPositionX: screenWidth > 1366 ? "-20%" : "-4%",
            // backgroundRepeat: "no-repeat",
            // backgroundSize: screenWidth > 1366 ? "96vh" : "80vh",
            // backgroundAttachment: "local"
          }}
        >
          <Box sx={{ width: "100%", padding: "20px 0px 60px 20px" }} display="flex" flexDirection="column" gap="60px">
            <Header />
            <Stack sx={{ width: "100%" }} alignItems="center" direction="row" justifyContent="center">
              <AsyncContentMui isLoading={loading} spinnerProps={{ size: 300 }}>
                {data && (
                  <SocialComponent
                    data={data}
                    btnTitle="Edit Profile"
                    btnHandler={() => setIsEditOpen(true)}
                    updatePhotoProfile={handleChangeAvatar}
                  />
                )}
              </AsyncContentMui>
            </Stack>
          </Box>
        </Container>
        {metadata && data && (
          <EditWindow
            userId={userId}
            isOpen={isEditOpen}
            onClose={() => setIsEditOpen(false)}
            profileData={data}
            refetchUserData={getProfile}
            profileMetadata={metadata}
            updateProfile={updateProfileDataAction}
          />
        )}
      </RoleComponentGuard>
    )
  );
};
